import { useState, useEffect } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../util/firebase";
import { query, collection, getDocs, where } from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

import { useTranslation } from "react-i18next";

function UserInfoPage() {
  const { t } = useTranslation("common");

  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [country, setCountry] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setFirstName(data.firstName);
      setLastName(data.lastName);
      setEmail(data.email);
      setPhoneNumber(data.phoneNumber);
      setCountry(data.country);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="changeUsernamePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        {t("userInfo").toUpperCase()}
      </h1>
      <div>
        <p
          className="inputLabel"
          style={{ textAlign: "left", color: "#FFFFFF" }}
        >
          {t("firstName")}
        </p>
        <input
          type="text"
          className="mainInput"
          value={firstName}
          style={{ marginBottom: "0.5rem" }}
          disabled
        />
        <p
          className="inputLabel"
          style={{ textAlign: "left", color: "#FFFFFF" }}
        >
          {t("lastName")}
        </p>
        <input
          type="text"
          className="mainInput"
          value={lastName}
          style={{ marginBottom: "0.5rem" }}
          disabled
        />
        <p
          className="inputLabel"
          style={{ textAlign: "left", color: "#FFFFFF" }}
        >
          {t("email")}
        </p>
        <input
          type="text"
          className="mainInput"
          value={email}
          style={{ marginBottom: "0.5rem" }}
          disabled
        />
        <p
          className="inputLabel"
          style={{ textAlign: "left", color: "#FFFFFF" }}
        >
          {t("phoneNumber")}
        </p>
        <input
          type="text"
          className="mainInput"
          value={phoneNumber}
          style={{ marginBottom: "0.5rem" }}
          disabled
        />
        <p
          className="inputLabel"
          style={{ textAlign: "left", color: "#FFFFFF" }}
        >
          {t("country")}
        </p>
        <input
          type="text"
          className="mainInput"
          value={country}
          style={{ marginBottom: "0.5rem" }}
          disabled
        />
      </div>
    </div>
  );
}

export default UserInfoPage;
